import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import type { MarketIdentifiers } from '$lib/types/market';
import { get } from 'svelte/store';
import { api } from './utils';
import { smartWalletCreationPending } from '$lib/wallet/store';
import { ZERO_ADDRESS } from '$lib/web3/addresses';

export async function fetchMargin(market: MarketIdentifiers) {
	if (!get(smartContractWalletAddress) || !market) return;
	const response = await api(
		'get',
		`snx-perps/users/${get(smartContractWalletAddress)}/margin?marketIdentifier=${market}`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchPostTradeDetails(
	size: string,
	marketId: MarketIdentifiers,
	marginDelta: string,
	pythPrice?: string
) {
	let scAddress = get(smartContractWalletAddress);
	if (!scAddress || get(smartWalletCreationPending)) {
		scAddress = ZERO_ADDRESS;
	}
	const response = await api('post', `snx-perps/markets/${marketId}/quote/v4`, {
		sizeDelta: size,
		marginDelta: marginDelta,
		account: scAddress,
		pythPrice: pythPrice ? pythPrice : undefined
	});

	if (response.status === 201) {
		const data = await response.json();
		return data;
	} else {
		console.log('Something went wrong.');
	}
}

export async function fetchAllMargin() {
	if (!get(smartContractWalletAddress)) return;
	const response = await api(
		'get',
		`snx-perps/users/${get(smartContractWalletAddress)}/all-markets-margin-v2`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchShouldUpdateKeeperFee() {
	const response = await api('get', `snx-perps/should-update-min-keeper-fee`);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
